export function getCookieDomain(host: string | undefined) {
  const parts = (host || '').split('.');
  if (parts.length < 2) {
    return;
  }

  return `.${parts.slice(-2).join('.')}`;
}
